const RoomFacilitator = ({sessionData, facilitatorInsRef}) => {

	return (
		<div className='discussion-room-broadcast discussion-room-card' ref={facilitatorInsRef}>
			<p className="topik-diskusi-title">
				Instructions for facilitator:
			</p>
			<p className="topik-diskusi-content">
				{sessionData['instruksi_fasilitator']}
			</p>
			
		</div>
	);
}
 
export default RoomFacilitator;